const types={
  INIT: "INIT",
  INIT_AUTH_DATA: "INIT_AUTH_DATA",
  RESET_AUTH_DATA: "RESET_AUTH_DATA",
  SIDEBAR_INIT: "SIDEBAR_INIT",
  INIT_USER_INFO: "INIT_USER_INFO",
  LOADING_OFF: "LOADING_OFF",
  LOADING_ON: "LOADING_ON",
};
export default types;